import { Controller } from "@hotwired/stimulus"

const DEFAULT_TAB = "content"
const TABS = [ "content", "advanced", "seo" ]

// Connects to data-controller="admin--page-drawer-form"
export default class extends Controller {
  static targets = [ "tabButton", "tabPanel" ]
  static values = {
    defaultTab: String
  }

  connect() {
    this.activeTab = this.normalizeTab(this.defaultTabValue)
    this.applyTabs()
  }

  switchTab(event) {
    if (event) event.preventDefault()
    const requested = event?.currentTarget?.dataset?.tabKey
    this.activeTab = this.normalizeTab(requested)
    this.applyTabs()
  }

  applyTabs() {
    this.tabButtonTargets.forEach((button) => {
      const tab = this.normalizeTab(button.dataset.tabKey)
      const active = tab === this.activeTab
      button.setAttribute("aria-selected", active ? "true" : "false")
      button.classList.toggle("bg-foreground", active)
      button.classList.toggle("text-background", active)
      button.classList.toggle("border-foreground", active)
      button.classList.toggle("border", active)
      button.classList.toggle("text-muted-foreground", !active)
      button.classList.toggle("hover:text-card-foreground", !active)
    })

    this.tabPanelTargets.forEach((panel) => {
      const tab = this.normalizeTab(panel.dataset.tabPanelKey)
      panel.classList.toggle("hidden", tab !== this.activeTab)
    })
  }

  normalizeTab(value) {
    return TABS.includes(value) ? value : DEFAULT_TAB
  }
}
